export default "__VITE_ASSET__CUXnXQqB__"